import nestAxios from './_nestAxios'

export const get = _id => nestAxios.get(`/activos-fijos/${_id}`)
export const getSelect = ({ cuenta }) =>
  nestAxios.get('/activos-fijos', {
    params: {
      tipoConsulta: 'select',
      cuenta: cuenta
    }
  })

export const getLibroActivosxId = idActivo =>
  nestAxios.get('/activos-fijos/libro-activos', {
    params: { idActivo: idActivo }
  })

export const nuevoCodigo = () => nestAxios.get('/activos-fijos/nuevo-codigo')

export const descargarPlantilla = () =>
  nestAxios.get('/activos-fijos/descargar/plantilla', {
    responseType: 'blob'
  })

export const descargarReporteActivos = params => nestAxios.get('/activos-fijos/descargar/reporte-activos', { responseType: 'blob', params: params })

export const actualizar = (_id, data) => nestAxios.put(`/activos-fijos/${_id}`, data)

export const nuevo = data => nestAxios.post('/activos-fijos', data)

export const nuevoActivoModal = data => nestAxios.post('/activos-fijos/nuevo-modal', data)

// Flujos posteriores del activo: repotenciación, mejora y traslado.
export const getMovimientos = idActivo => nestAxios.get(`/activos-fijos/${idActivo}/movimientos`)

export const registrarRepotenciacion = (idActivo, data) => nestAxios.post(`/activos-fijos/${idActivo}/repotenciacion`, data)

export const registrarMejora = (idActivo, data) => nestAxios.post(`/activos-fijos/${idActivo}/mejora`, data)

export const registrarTraslado = (idActivo, data) => nestAxios.post(`/activos-fijos/${idActivo}/traslado`, data)

export const importarActivosFijos = data => nestAxios.post('/activos-fijos/importar', data)

export const eliminar = _id => nestAxios.delete(`/activos-fijos/${_id}`)
